import React from "react";
import {useNavigate} from "react-router-dom";
import Icon from "../components/ui/Icon";

const CREDITS = [
    {
        name: "Cburnett",
        what: "the chess piece designs",
        href: "https://commons.wikimedia.org/wiki/User:Cburnett"
    },
    {
        name: "react-chessboard",
        what: "the interactive chess board",
        href: "https://github.com/Clariity/react-chessboard"
    },
    {
        name: "Kenney",
        what: "the sound effects (CC0)",
        href: "https://kenney.nl/assets"
    },
    {
        name: "Stockfish",
        what: "the engine behind game analysis and the computer opponent (GPL licensed)",
        href: "https://stockfishchess.org/"
    },
    {
        name: "Stockfish.js",
        what: "running Stockfish right in your browser when you play the computer",
        href: "https://github.com/nmrugg/stockfish.js"
    },
    {
        name: "SVGBackgrounds.com",
        what: "animated SVG preloaders",
        href: "https://www.svgbackgrounds.com/elements/animated-svg-preloaders/"
    },
    {
        name: "Google Fonts",
        what: "the Fraunces and Nunito typefaces (via Fontsource)",
        href: "https://fonts.google.com/"
    }
];

const Credits = () => {
    const navigate = useNavigate();

    return (
        <div className="page page--narrow">
            <div className="page-header">
                <div>
                    <div className="eyebrow">Credits</div>
                    <h1>Thank you</h1>
                    <p>A special thanks to everyone whose code, images and ideas helped make this website possible.
                        Have an idea yourself? <button type="button" className="link-btn" onClick={() => navigate("/feedback")}>Send us feedback</button>.</p>
                </div>
            </div>
            <div className="card">
                {CREDITS.map((credit, index) => (
                    <a key={credit.name} href={credit.href} target="_blank" rel="noreferrer"
                       className="history-row" style={{gridTemplateColumns: "minmax(0, 1fr) auto", borderTop: index === 0 ? 0 : undefined, color: "inherit", textDecoration: "none"}}>
                        <div>
                            <div className="history-row__name">{credit.name}</div>
                            <div className="history-row__sub">for {credit.what}</div>
                        </div>
                        <span className="history-row__go"><Icon name="arrowRight"/></span>
                    </a>
                ))}
            </div>
        </div>
    )
}

export default Credits;
